import { Input } from 'antd';
import type { SearchProps } from 'antd/es/input/Search';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import SVGIcon from '../SVGIcon';
import SearchIcon from '@/assets/imgs/search.svg?react';
const InputContainer = styled(Input)``;
interface SearchInputProps extends SearchProps {
  defaultValue?: string;
  onSearch?: (value: string) => void;
}
const SearchInput = ({ defaultValue = '', onSearch, onChange, ...props }: SearchInputProps) => {
  const [keyword, setKeyword] = useState(defaultValue);
  useEffect(() => {
    setKeyword(defaultValue);
  }, [defaultValue]);
  return (
    <InputContainer
      value={keyword}
      placeholder="搜索"
      allowClear
      onChange={(e: any) => {
        if (!e.target.value) {
          onSearch?.('');
        }
        setKeyword(e.target.value);
        onChange?.(e);
      }}
      onPressEnter={(e: any) => {
        onSearch?.(e.target.value);
      }}
      prefix={
        <SVGIcon
          icon={<SearchIcon />}
          onClick={() => {
            onSearch?.(keyword);
          }}
        />
      }
      {...props}
    />
  );
};
export default SearchInput;
